import { updateService } from "../../api/serviceService";

export const useUpdateService = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateService(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update service:", error);
        throw error;
    }
  };

  return { update };
};